import { render, staticRenderFns } from "./chargeConfirm.vue?vue&type=template&id=365f12b2&"
import script from "./chargeConfirm.vue?vue&type=script&lang=js&"
export * from "./chargeConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('365f12b2')) {
      api.createRecord('365f12b2', component.options)
    } else {
      api.reload('365f12b2', component.options)
    }
    module.hot.accept("./chargeConfirm.vue?vue&type=template&id=365f12b2&", function () {
      api.rerender('365f12b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PMS/customerService/houseDeliveryManage/decorationRegistration/chargeConfirm.vue"
export default component.exports